import React from "react";
import Chart from "react-apexcharts";
import ChartCard from "./ChartCard";
import { baseChartOptions } from "./chartTheme";

const CHART_ID = "queue-time-metrics";

interface QueueTimeData {
  week: string;
  avgTime: number;
  medianTime: number;
  minTime: number;
  maxTime: number;
  count: number;
}

interface QueueTimeMetricsChartProps {
  data?: QueueTimeData[];
}

const QueueTimeMetricsChart: React.FC<QueueTimeMetricsChartProps> = ({
  data = [],
}) => {
  const safeData: QueueTimeData[] =
    data.length > 0
      ? data
      : [
          {
            week: "Week 1",
            avgTime: 0,
            medianTime: 0,
            minTime: 0,
            maxTime: 0,
            count: 0,
          },
        ];

  const categories = safeData.map((item) => item.week);
  const avgData = safeData.map((item) => item.avgTime);
  const medianData = safeData.map((item) => item.medianTime);
  const minData = safeData.map((item) => item.minTime);
  const maxData = safeData.map((item) => item.maxTime);

  const series = [
    { name: "Average", data: avgData },
    { name: "Median", data: medianData },
    { name: "Minimum", data: minData },
    { name: "Maximum", data: maxData },
  ];

  const base = baseChartOptions(CHART_ID);
  const options = {
    ...base,
    chart: { ...base.chart, type: "line" },
    colors: ["#2563eb", "#15803d", "#b45309", "#dc2626"],
    xaxis: { categories },
    stroke: { curve: "smooth", width: 3 },
    markers: { size: 3, hover: { size: 5 } },
    tooltip: {
      ...base.tooltip,
      y: { formatter: (val: number) => `${val} min` },
    },
  };

  return (
    <ChartCard
      title="Queue Time Metrics by Week"
      description="Shows average, median, minimum, and maximum queue times (in minutes) for each week."
      chartId={CHART_ID}
    >
      <Chart options={options} series={series} type="line" height={300} />
    </ChartCard>
  );
};

export default QueueTimeMetricsChart;
